import { LinkStorage, Link, LegacyLink } from '../../types';
import * as ls from '../../helpers/localStorage';
import { FORMAT_OPTIONS } from '../../constants';

const KEY = 'links';

const migrateLegacyData = (storage: LinkStorage) => {
  if (storage.getList().length > 0) return;

  // do nothing if local storage already contains prefixed key
  const isMigrated = !!Object.keys(localStorage).find(key => key.indexOf(`${KEY}:`) !== -1);
  if (isMigrated) return;

  ls.set(storage.key, ls.get(KEY) || []);
};

export const createStorage = (prefix?: string) => {
  const key = prefix ? `${KEY}:${prefix}` : KEY;
  const getLegacyList = () => {
    return (ls.get(key) as LegacyLink[]) || [];
  };

  const storage: LinkStorage = {
    key,
    getList: () =>
      getLegacyList()
        .map((item, legacyIndex) => ({ ...item, legacyIndex }))
        .filter(item => !item.isMigrated)
        .map(formatLink),
    markAsMigrated: index => {
      const list = getLegacyList();
      list[index] = { ...list[index], isMigrated: true };
      ls.set(key, list);
    },
  };

  migrateLegacyData(storage);

  return storage;
};

const formatLink = ({
  link,
  isArchived,
  adEnvironment,
  title,
  format,
  legacyIndex,
}: LegacyLink & { legacyIndex: number }): Omit<Link, 'id'> & { legacyIndex: number } => {
  if (!title && format) {
    const formatOption = FORMAT_OPTIONS.find(option => option.value === format);
    if (formatOption) {
      title = formatOption.label;
    }
  }

  return {
    url: link,
    archived_at: isArchived ? new Date().toISOString() : undefined,
    ad_environment: adEnvironment,
    title,
    legacyIndex,
  };
};
